import React from 'react';
import { useSpring, animated } from 'react-spring';
import './ThankYouPage.css';

const ThankYouPage = () => {
  const animationProps = useSpring({ opacity: 1, from: { opacity: 0 } });

  return (
    <animated.div className="thank-you-container" style={animationProps}>
      <h1 className="thank-you-title">Thank You! 🎉</h1>
      <p className="thank-you-message">
        Thanks a bunch for filling that out. It means a lot to us, just like you do! 🙌
        We really appreciate you giving us a moment of your time today. Thanks for being you. 😊
      </p>
    </animated.div>
  );
};

export default ThankYouPage;
